import { motion } from 'framer-motion'

/**
 * --------------------------------------------------------------------------
 * SlideToggle Component (Externally Controlled, No DOM Removal)
 *
 * @param bool   $open      - Whether the content is visible or not
 * @param node   $children  - The content to animate
 * @param object $options   - Optional animation options (duration, easing)
 * --------------------------------------------------------------------------
 **/
const SlideToggle = ({ open, children, options = {} }) => {
  const { duration = 0.3, ease = 'easeInOut' } = options

  return (
    <motion.div
      className="print:!block print:!h-auto print:!overflow-visible print:!opacity-100"
      initial={!open ? { height: 0, opacity: 0 } : { height: 'auto', opacity: 1 }}
      animate={{
        height: open ? 'auto' : 0,
        opacity: open ? 1 : 0,
      }}
      transition={{ duration, ease }}
      style={{
        overflow: 'hidden',
        display: open ? 'block' : 'block', // Always display to retain layout
      }}>
      {children}
    </motion.div>
  )
}

export default SlideToggle
